/* eslint-disable react/jsx-no-duplicate-props */
import React, {useRef, useState, Fragment} from "react";
import {Row, Col, Button} from "react-bootstrap";
import {useAsyncSetState} from "use-async-setstate";
import Formsy from "formsy-react";
import {Link, navigate} from "gatsby";
import TextField from "../bootstrap/input";
import Captcha from "../bootstrap/captcha";


export default function Index(props) {
  const [loading, setLoading] = useAsyncSetState(false);
  const [errorMessage, setErrorMessage] = useAsyncSetState(null);
  const [captchaRefreshKey, setRefreshKey] = useAsyncSetState(new Date());
  const [email, setEmail] = useState("");
  const [captcha, setCaptcha] = useState("");
  const {showForgotRequested, setShowForgotRequested} = props;

  const formRef = useRef(null);

  const handleSubmit = async ({email, captcha, captchaKey}) => {
    try {
      await setLoading(true);
      const response = await fetch(
        `${process.env.BACKEND_URL}rest.api/change-password-request`,
        {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            captcha,
            captchaKey,
          }),
        }
      );
      switch (response.status) {
        case 503:
          await setErrorMessage(() => <>{"An error has occurred"}</>);
          await setRefreshKey(new Date());
          break;
        case 401:
          await setRefreshKey(new Date());
          const {error} = await response.json();
          switch (error) {
            case "EEXISTS":
              await setErrorMessage(() => (
                <>
                  {"This email address already registered, "}
                  <Link to="/forgot-password">{"Click Here"}</Link>
                  {" to reset your password"}
                </>
              ));
              break;
            case "ECAPTCHA":
              await setErrorMessage(() => (
                <>{"Invalid captcha code provided"}</>
              ));
              break;
            default:
              await setErrorMessage(error);
              break;
          }
          break;
        case 200:
          await setErrorMessage(null);
          setShowForgotRequested(true);
      }
    } catch (err) {
      // console.log("err", err);
      await setErrorMessage("An error has occurred");
    }
    return setLoading(false);
  };

  const submitButtonComponent = () => {

    window.addEventListener("storage", () => {
      const input = sessionStorage.getItem("captcha");
      setCaptcha(input);
    });


    if (email !== "" && captcha !== "" && captcha.length >= 6) {
      return (
        <div className="vw-button-container">
          <Button
            className="vw-button"
            type="submit"
            disabled={loading}
            onClick={() => formRef.current.submit()}
          >
            {"Request"}
          </Button>
        </div>
      );
    } else {
      return (
        <div className="vw-button-container">
          <Button
            className="vw-button disabled"
            type="submit"
            disabled
          >
            {"Request"}
          </Button>
        </div>
      );
    }
  };

  return (
    <>
      {showForgotRequested ? (
        <div className="password-change-requested">
          <h3>Change Password Requested</h3>
          <p>A change password link is sent to your provided email address.</p>                
          <Button
            className=""
            type="submit"
            disabled={loading}
            onClick={() => navigate("/")}
          >
            {"Close"}
          </Button>
      </div>
      ) : (
        <Fragment>
          <Formsy ref={formRef} onValidSubmit={handleSubmit}>
            <Row className="field-row-address">
              <Col xs={12} className="vw-recover-pass-field">
                <TextField
                  className="vw-form-field"
                  name="email"
                  autoComplete="off"
                  onChange={e => setEmail(e.target.value)}
                  placeholder="your email address"
                  disabled={loading}
                  hideRequiredMark
                  required
                  label={"Email"}
                />
              </Col>
            </Row>
            <Row
              className="field-row-cap"
            >
              <Col className="vw-captcha-field">
                <Captcha
                  name="captcha"
                  refreshKey={captchaRefreshKey}
                  submitButtonComponent={submitButtonComponent}
                />
              </Col>
            </Row>
            {errorMessage && (
            <Row>
              <Col>
                <div className="alert alert-danger">
                  <i
                    className="fas fa-exclamation-circle"
                  />
                  {errorMessage}
                </div>
              </Col>
            </Row>
            )}
          </Formsy>
        </Fragment>
      )}
    </>
  );
}
